module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relative ml2 mt1",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.edit_title_mode),
      expression: "!edit_title_mode"
    }],
    staticClass: "flex middle-xs edit-container",
    on: {
      "click": function($event) {
        return _vm.editTitle()
      }
    }
  }, [_c('div', {
    staticClass: "pl-headline middle-xs truncate-text",
    staticStyle: {
      "font-weight": "bold",
      "white-space": "nowrap",
      "font-size": "24px"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.getCurrentDiscussion.title) + "\n      ")]), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse || _vm.needToChangeTitle) ? _c('div', {
    staticClass: "row middle-xs no-margin pencil-container",
    class: {
      'show-pencil': _vm.needToChangeTitle
    }
  }, [_c('i', {
    staticClass: "fas fa-pencil-alt",
    staticStyle: {
      "margin": "0px 10px",
      "font-size": "12px",
      "opacity": "0.6"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pl-body-1",
    attrs: {
      "id": 'onboarding-edit-roundtable-title'
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.edit_title_mode),
      expression: "edit_title_mode"
    }],
    ref: "edit-title-container",
    staticStyle: {
      "min-width": "80%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.roundtable_title),
      expression: "roundtable_title"
    }],
    ref: "edit-title",
    staticClass: "edit-rt-title-input",
    domProps: {
      "value": (_vm.roundtable_title)
    },
    on: {
      "focus": function($event) {
        _vm.edit_title_mode = true
      },
      "blur": function($event) {
        return _vm.saveTitle()
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.saveTitle()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.roundtable_title = $event.target.value
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-34c2c09f!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/components/editTitleInline.liveDiscussion.vue
// module id = 1743
// module chunks = 61